var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"core-element-info-message",attrs:{"color":"info","dense":"","icon":_vm.infoIcon,"outlined":""}},[_c('small',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }